var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleExclamationSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 -1.58972e-07C4.47656 -6.41846e-07 1.3571e-06 4.47656 8.74228e-07 10C3.91354e-07 15.5234 4.47656 20 10 20C15.5234 20 20 15.5234 20 10C20 4.47656 15.5234 3.23902e-07 10 -1.58972e-07ZM10 15C9.48047 15 9.0625 14.582 9.0625 14.0625L9.0625 9.6875C9.0625 9.16797 9.48047 8.75 10 8.75C10.5195 8.75 10.9375 9.16797 10.9375 9.6875L10.9375 14.0625C10.9375 14.582 10.5195 15 10 15ZM8.75 6.25C8.75 5.55859 9.3086 5 10 5C10.6914 5 11.25 5.55859 11.25 6.25C11.25 6.94141 10.6914 7.5 10 7.5C9.30859 7.5 8.75 6.94141 8.75 6.25Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleExclamationSolid);
export default __webpack_public_path__ + "static/media/circle-exclamation-solid.913f0305ee748903833595d51517532a.svg";
export { ForwardRef as ReactComponent };